import { useNavigate } from "react-router-dom";
import { FormBody, FormContentContainer, Header } from "../../components";
import { styled, Box, Link as MuiLink, Typography } from "@mui/material";
import { format as formatRut } from "rut.js";
import parsePhoneNumber from "libphonenumber-js";
import {
  InformationCardSubTitle,
  InformationCardText,
  InformationCardSection,
  NavigateBeforeButton,
} from "../../components";
import {
  getBirthdateInfo,
  onContactUsClick,
  parseRNPIDoctorBirthdate,
  separateDoctorSpecialty,
} from "../../utils";
import { useDoctorContext } from "../../context";
import { needHelpMessage } from "../../constants";

const ContactUsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "16px",
  color: theme.palette.text.black,
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "23px",
  letterSpacing: "0.5px",
}));

const Link = styled(MuiLink)(({ theme }) => ({
  textAlign: "center",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  color: theme.palette.text.link,
  cursor: "pointer",
}));

export const PersonalData = () => {
  const navigate = useNavigate();
  const {
    rut,
    name,
    lastName,
    speciality,
    birthdate,
    registrationNumber,
    email,
    phone,
  } = useDoctorContext();
  const { years: age } = getBirthdateInfo(birthdate);
  const { mekidocAccessTitle, specialties } =
    separateDoctorSpecialty(speciality);

  return (
    <>
      <Header
        useMekiDocIcon
        left={
          <NavigateBeforeButton onClick={() => navigate("/app/solicitudes")} />
        }
      />
      <FormContentContainer disableGutters>
        <FormBody>
          <Typography variant="h6" fontWeight={"medium"}>
            Datos personales
          </Typography>
          <InformationCardSection>
            <Box>
              <InformationCardSubTitle variant="body2">
                Nombre
              </InformationCardSubTitle>
              <InformationCardText variant="body1">
                {name} {lastName}
              </InformationCardText>
            </Box>
            <Box>
              <InformationCardSubTitle variant="body2">
                Rut
              </InformationCardSubTitle>
              <InformationCardText variant="body1">
                {formatRut(rut)}
              </InformationCardText>
            </Box>
            <Box>
              <InformationCardSubTitle variant="body2">
                Fecha de nacimiento
              </InformationCardSubTitle>
              <InformationCardText variant="body1">
                {age} años · {parseRNPIDoctorBirthdate(birthdate)}
              </InformationCardText>
            </Box>
            <Box>
              <InformationCardSubTitle variant="body2">
                Titulo y especialidad
              </InformationCardSubTitle>
              <InformationCardText variant="body1">
                {mekidocAccessTitle} (REG-SIS N°: {registrationNumber}){" "}
                {specialties}
              </InformationCardText>
            </Box>
            <Box>
              <InformationCardSubTitle variant="body2">
                Correo electrónico
              </InformationCardSubTitle>
              <InformationCardText variant="body1">{email}</InformationCardText>
            </Box>
            <Box>
              <InformationCardSubTitle variant="body2">
                Teléfono celular
              </InformationCardSubTitle>
              <InformationCardText variant="body1">
                {parsePhoneNumber(phone)?.formatInternational()}
              </InformationCardText>
            </Box>
          </InformationCardSection>

          <ContactUsContainer>
            Si necesitas editar tus datos{" "}
            <Link
              onClick={() => {
                onContactUsClick(needHelpMessage);
              }}
            >
              contáctanos
            </Link>
          </ContactUsContainer>
        </FormBody>
      </FormContentContainer>
    </>
  );
};
